module.exports = __webpack_public_path__ + "img/modulo_Line.a9814ce.svg";